import { useMutation, useQueryClient } from '@tanstack/react-query';

import ApiCart from '@Api/Cart';
import useCartKeys from './useCartKeys';

import type { CartData } from '@Types/Cart';

interface ApplyPromocodeBody {
  [key: string]: string | number;
}

export const useApplyPromocode = () => {
  const queryClient = useQueryClient();
  const keys = useCartKeys();

  const { mutate, isPending } = useMutation({
    mutationFn: async (coupon: ApplyPromocodeBody) => {
      const res = await ApiCart.sendCheckerPromocode(coupon);
      return res;
    },
    onSuccess: (NewCart) => {
      queryClient.setQueriesData({ queryKey: keys }, (prev: CartData) => {
        return {
          ...prev,
          ...NewCart,
        };
      });
    },
  });

  return {
    applyPromocode: mutate,
    isPending,
  };
};

export default useApplyPromocode;
